var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert-page',{attrs:{"emoji":"🤷‍","title":"מספר הטלפון שלך לא קיים אצלנו במערכת","show-button":true,"button-title":"להרשמה","button-action":_vm.goToSignup,"show-support-footer":true}})}
var staticRenderFns = []

export { render, staticRenderFns }